import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { User } from 'src/app/entities/user.entity';
import { Router, ActivatedRoute } from '@angular/router';
import { ModelService } from 'src/app/services/model.service';
import { UserListService } from '../user-list/user-list.service';
import { LoginService } from 'src/app/login/login_service/login.service';
import { ConfigService } from 'src/app/app.config';
import { AlertData } from 'src/app/alert/alert-data.entity';
import { FileUploader, FileLikeObject, FileUploaderOptions } from 'ng2-file-upload';
import { UserDetailService } from './user-detail.service';
import { logging } from 'protractor';
import { NgForm } from '@angular/forms';
import { Utils } from 'src/app/utils.module';
import { Store } from '@ngrx/store';
import * as pathActions from '../../store/path/path.actions';
import { AppState } from 'src/app/app.reducers';

declare let ga: (param1: string, param2: string, param3: any) => {};

@Component({
	selector: 'app-user-detail',
	templateUrl: './user-detail.component.html',
	styleUrls: ['./user-detail.component.scss']
})
export class UserDetailComponent implements OnInit, AfterViewInit {

	private path = '';

	public uploader: FileUploader;
	public hasBaseDropZoneOver: boolean = false;
	public hasAnotherDropZoneOver: boolean = false;

	@ViewChild('profileForm', { static: false }) profileForm: NgForm;
	@ViewChild('alertWindow', { static: false }) alertWindow: any;
	@ViewChild('idlogo', { static: false }) _idlogo: ElementRef;

	private allowedMimeType: string[] = ['image/jpg', 'image/jpeg'];
	private maxFileSize: number = 10 * 1024 * 1024;
	public errorMessage: string;
	public userData: User = new User();
	private subs: Subscription;

	public userImageURL: string;
	public isImageSaved: boolean;
	private cacheUser: User;

	//TODO Cuando vuelve del detalle del user.
	private _listOrder = {};
	private _listCurrentPage = 0;
	private _listItemsByPage = 10;
	private _listCurrentFilter = '1';


	public loading = false;

	constructor(
		private store: Store<AppState>,
		private router: Router,
		public modelService: ModelService,
		private userListService: UserListService,
		private userProfileService: UserDetailService,
		private loginService: LoginService,
		private route: ActivatedRoute
		// private router: Router
	) {

		const uploaderOptions: FileUploaderOptions = {
			url: ConfigService.REST_SERVER + '/api/upload/user/' + modelService.getUser().getData().id,
			allowedMimeType: this.allowedMimeType,
			autoUpload: true,
			isHTML5: true,
			method: 'POST',
			authToken: 'Bearer ' + modelService.getUser().authToken,
			maxFileSize: this.maxFileSize,
			queueLimit: 1
		};

		this.uploader = new FileUploader(uploaderOptions);

		this.uploader.onAfterAddingFile = (file) => {
			file.alias = 'userImage';
			file.withCredentials = false;
		};

		this.uploader.onWhenAddingFileFailed = (item, filter, options) => {
			this.onWhenAddingFileFailed(item, filter, options);
		};

		this.uploader.onCompleteItem = (file) => {
			this.modelService.getUser().userUpdatedSignal.emit(true);
			this.userImageURL = this.modelService.getUser().getImageWithSize(430, 260, this.userData.id);
			this.errorMessage = this.modelService.getString('user_profile_image_success');

			ga('send', 'event', {
				eventCategory: 'Perfil de usuario',
				eventAction: 'Imagen actualizada',
				eventLabel: 'true'
			});
		};

		this.modelService.showDataUser.subscribe((datos) => {
			this.iniciar();
		});

		// this.userImageURL = this.modelService.ge tUser().getImageWithSize(430, 260, this.userData.id);
	}

	public isActive() { return true; }; //(this.userData.estado === 1); }
	public isDisable() { return (this.userData.estado === 0); }
	public isWait() { return (this.userData.estado === 2); }
	public isDelete() { return (this.userData.estado === 3); }

	fileChangeEvent(fileInput: any) {
		if (fileInput.target.files && fileInput.target.files[0]) {
			// Size Filter Bytes
			const max_size = 20971520;
			const allowed_types = ['image/jpeg'];
			const max_height = 25500;
			const max_width = 25500;

			if (fileInput.target.files[0].size > max_size) {
				this.errorMessage = this.modelService.getString('user_profile_filesize_error') + ' ' + fileInput.target.files[0].size + 'Mb ' + this.modelService.getString('user_profile_total_of') + max_size / 1000 + ' Mb';
				return false;
			}

			if (!allowed_types.includes(fileInput.target.files[0].type)) {
				this.errorMessage = this.modelService.getString('user_profile_mimetype_error');
				return false;
			}

			const reader = new FileReader();
			reader.onload = (e: any) => {
				const image = new Image();
				image.src = e.target.result;
				image.onload = rs => {
					const img_height = rs.currentTarget['height'];
					const img_width = rs.currentTarget['width'];

					if (img_height > max_height && img_width > max_width) {
						this.errorMessage = this.modelService.getString('user_profile_max_dimensions_allowed_error') + max_height + '*' + max_width + 'px';
						return false;
					} else {
						const imgBase64Path = e.target.result;
						this.userImageURL = imgBase64Path;
						this.isImageSaved = true;
						this.userProfileService.uploadImage(this.modelService.getUser().getData().id, this.userImageURL);
					}
				};
			};
			reader.readAsDataURL(fileInput.target.files[0]);
		}
	}

	public ngOnInit() {
		this.loginService.isLoggedIn();
		var i = document.getElementById('webContents');
		if (i) i.setAttribute('style', "");

		this.store.subscribe(state => {
			this.path = state.uiPath.path;
			this._listOrder = state.listUsers.order;
			this._listItemsByPage = state.listUsers.itemsByPage;
			this._listCurrentPage = state.listUsers.currentPage;
			this._listCurrentFilter = state.listUsers.currentFilter.toString();
			console.log('---> UsrDetail PATH:: ', this.path);
		});

		this.iniciar();
	}

	public ngAfterViewInit() {
		for (var i in this.profileForm.controls) {
			if (this.profileForm.controls[i]) {
				this.profileForm.controls[i].markAsTouched();
			}
		}
		this.refrescoImagen();
	}

	private maximoTiempo = 0;
	private refrescoImagen() {
		if (this.maximoTiempo > 3000) {
		}
		else {
			if (this._idlogo) {
				if (this._idlogo.nativeElement.width > 0) {
					if (this._idlogo.nativeElement.width == 1) {
						this.isImageSaved = false;
						return;
					} else {
						this.isImageSaved = true;
					}
				}
			}
			setTimeout(() => { this.refrescoImagen(); }, 200);
			this.maximoTiempo += 200;
		}
	}

	// Actualiza los datos del registro.
	public updateProfile() {
		this.loading = true;
		this.subs = this.userProfileService.update(this.userData).subscribe((result) => {
			console.log('-------------------------------------------');
			console.log(this.subs);
			console.log('-------------------------------------------');

			this.subs.unsubscribe();
			this.modelService.getUser().userUpdatedSignal.emit(true);

			if (this.modelService.getUser().getData().id === this.userData.userId) {
				this.mensaje('', this.modelService.getString('user_profile_reinit'), true);
			} else {
				this.mensaje('', this.modelService.getString('user_profile_success'), false);
			}
			this.loading = false;
		});
	}

	public removeImage() {
		this.subs = this.userProfileService.removeImage(this.userData).subscribe((result) => {
			this.subs.unsubscribe();
			this.userImageURL = this.modelService.getUser().getImageWithSize(430, 260, this.userData.id);
			this.isImageSaved = false;

			ga('send', 'event', {
				eventCategory: 'Perfil de usuario',
				eventAction: 'Imagen eliminada',
				eventLabel: 'true'
			});
		});
	}
	public fileOverBase(e: any): void { this.hasBaseDropZoneOver = e; }

	public fileOverAnother(e: any): void { this.hasAnotherDropZoneOver = e; }

	private mensaje(titulo: string, texto: string, loginarse: boolean) {
		const data: AlertData = new AlertData();
		data.title = titulo;
		data.message = texto;
		data.relogin = loginarse;
		this.alertWindow.show(data);

		const sub = this.modelService.alertResultSignal.subscribe((dt: AlertData) => {
			sub.unsubscribe();
			this.alertWindow.close();
			if (data.relogin) {
				this.loginService.logout();
				localStorage.removeItem(Utils.CURRENT_PROJECT);
				this.router.navigate(['/login']);
			} else {
				//console.log(`this._listCurrentFilter ${this._listCurrentFilter}, this._listOrder ${this._listOrder}, this._listCurrentPage ${this._listCurrentPage}, this._listItemsByPage ${this._listItemsByPage}`);
				this.userListService.getCurrentList(this._listCurrentFilter, this._listOrder, this._listCurrentPage, this._listItemsByPage);
				this.router.navigate(['/user-list']);
				this.store.dispatch(pathActions.goFront({path:'/user-list'}));
			}
		});
	}
// FIXME
	/*private copyCacheUser(userData: User) {
		if (userData) {
			this.cacheUser = new User();
			this.cacheUser.id = userData.id;
			this.cacheUser.empresa = userData.empresa;
			this.cacheUser.cif_nif = userData.cif_nif;
			this.cacheUser.email = userData.email;
			this.cacheUser.password = userData.password;
			this.cacheUser.nombre = userData.nombre;
			this.cacheUser.apellidos = userData.apellidos;
			this.cacheUser.numCliRivisa = userData.numCliRivisa;
			this.cacheUser.idioma = userData.idioma;
			this.cacheUser.estado = userData.estado;
			this.cacheUser.rol = userData.rol;
			this.cacheUser.lastProjects = userData.lastProjects;
		}
	}*/

	private iniciar() {
		this.route.params.subscribe((params) => {
			// Si no viene el parámetro 'id' o si viene es igual al usuario loginado.
			const idString: any = (params['id']) ? params.id : this.modelService.getUser().getData().id;

			this.userProfileService.getUser2(idString).subscribe((result) => {
				//console.log(result.result);
				this.userData = result.result;
				this.userData['userId'] = this.userData._id;
				this.uploader.options.url = ConfigService.REST_SERVER + '/api/upload/user/' + this.userData.userId;
				this.userImageURL = this.modelService.getUser().getImageWithSize(430, 260, this.userData.userId);
			});
		});

		// this.copyCacheUser(this.userData);
	}

	private onWhenAddingFileFailed(item: FileLikeObject, filter: any, options: any) {
		switch (filter.name) {
			case 'fileSize':
				this.errorMessage = this.modelService.getString('user_profile_filesize_error') + '(${item.size}, de un total de ${this.maxFileSize})';
				break;
			case 'mimeType':
				this.errorMessage = this.modelService.getString('user_profile_mimetype_error');
				break;
			default:
				this.errorMessage = this.modelService.getString('user_profile_default_error');
		}
	}

	public myself(): boolean {
		return (this.modelService.getUser().getData().id === this.userData.userId);
	}

	// Solo se pueden eliminar usuarios, no SuperAdmins ni Admins.
	public systemDeleteUsers(): boolean {
		return this.modelService.getUser().isSuperAdmin && (this.userData.rol === 0 || this.userData.rol === 10);
	}

	//public deleteUser() {
	//Si el usuario está en espera, avisar que será eliminado.
	//	Si: Se elimina el usuario y se vuelve al listado de usuarios.
	//	No: Volver al perfil
	//else
	//Si el usuario ya está eliminado, avisar que se pierde todo sin recuperación.
	//	Si: Eliminar usuario y proyectos.
	//  No: Volver al perfil
	//else
	//Si el usuario está en Activo o Desactivado
	//	Adquirir cantidad de proyectos
	//		Si tiene proyectos avisar
	//			Si: pasar el usuario y proyectos a estado eliminado.
	//			No: Volver al perfil
	//		No tiene avisar
	//			Si: eliminar el usuario
	//			No: volver perfil
	//	this.mensajeDeleteUser();
	//}

	// Mensajes de borrado.
	// Eliminar cuando tiene proyectos.
	// 1.- Eliminar usuario y proyectos si los tiene.
	// 2.- Usuario y proyectos pasan a Eliminados.

	// El usuario tiene n proyectos creados, no será eliminado de la base de datos pero estará en estado 'Eliminado', con lo cual se podría recuperar el usuario y sus proyectos. ¿Desea continnuar?
	// El usuario será eliminado de la base de datos y no podrá ser recuperado. ¿Desea continuar?
	// El usuario ya fue eliminado y tiene proyectos, está acción eliminará por completo tanto el usuario como sus proyectos sin posibilidad de recuperación. ¿Desea continnuar?

	// El usuario fue eliminado, está acción se recupera el usuario y sus proyectos. El usuario aparecera como desactivado. ¿Desea continuar?
	public deleteUser() {

		// Si ya está eliminado
		//console.log('ESTADO :: ', this.userData.estado);
		if (this.userData.estado === '3') { //console.log('ESTADO 3');
			this.eliminarUserConProyectos(0, true);
		}
		// Si está en espera de aceptación.
		else if (this.userData.estado === '2') { //console.log('ESTADO 2');
			this.elimiarUserSinProyectos();
		}
		// Esta activo o desactivado.
		else {
			//console.log('ESTADO 0/1');
			this.userProfileService.getProjectsCountUser(this.userData.userId).subscribe((result) => {
				if (result.count === 0 || result.count === undefined) {
					this.elimiarUserSinProyectos();
				}
				else {
					this.eliminarUserConProyectos(result.count);
				}
			});
		}
	}

	private elimiarUserSinProyectos() {
		const data: AlertData = new AlertData();
		data.messages = this.modelService.getString('user_profile_delete_user_body').split('#');
		data.title = this.modelService.getString('user_profile_delete_user_title');
		data.type = 'modal';
		this.alertWindow.show(data);

		const subWindow = this.modelService.alertResultSignal.subscribe((shouldRemove: boolean) => {
			subWindow.unsubscribe();
			this.alertWindow.close();
			//console.log(shouldRemove);
			if (shouldRemove) {
				// Eliminar usuario.
				this.userProfileService.deleteUser(this.userData.userId).subscribe((result) => {
					console.log('DELETE::', result);
					if (result.result.ok === true) {
						//console.log('Goback');
						this.router.navigate([this.path]);
						this.store.dispatch(pathActions.goBack());
						// TODO Lanzar evento para actualizar listado de usuarios.
						this.modelService.getUser().userChangeSignal.emit('');
					}
				});
			}
		});
	}

	private eliminarUserConProyectos(count: number, force: boolean = false) {
		const data: AlertData = new AlertData();
		if (!force) {
			let mensaje =  this.modelService.getString('user_profile_stateDelete_userProjects_body');
			mensaje = mensaje.replace('{DATA}', count.toString());
			data.messages = mensaje.split('#');
		} else data.messages = this.modelService.getString('user_profile_delete_userProjects_body').split('#');

		data.title = this.modelService.getString('user_profile_delete_userProjects_title');
		data.type = 'modal';
		this.alertWindow.show(data);

		const subWindow = this.modelService.alertResultSignal.subscribe((shouldRemove: boolean) => {
			subWindow.unsubscribe();
			this.alertWindow.close();
			//console.log(shouldRemove);
			if (shouldRemove) {
				if (!force) {
					this.userProfileService.changeUserToDelete(this.userData.userId).subscribe((res) => {
						if (res.result.ok === true) { //console.log('Goback');
							this.router.navigate([this.path]);
							this.store.dispatch(pathActions.goBack());
							this.modelService.getUser().userChangeSignal.emit('');
						}
					});
				}
				else {
					// Cambiar estado a eliminado.
					// Marcar proyecto como eliminados.
					this.userProfileService.deleteUser(this.userData.userId).subscribe((res) => {
						//console.log('DELETE::', res.result.projects);
						if (res.result.ok === true) { //console.log('Goback');
							this.router.navigate([this.path]);
							this.store.dispatch(pathActions.goBack());
							this.modelService.getUser().userChangeSignal.emit('');
						}
					});
				}
			}
		});
	}

	// Recupera un usuario con sus proyectos que estaba en estado Eliminado.
	public recoverUser() {
		this.mensajeRecoverUser();
		console.log(this.userData);
	}
	private mensajeRecoverUser() {
		const data: AlertData = new AlertData();
		data.messages = this.modelService.getString('user_profile_recover_user_body').split('#');
		data.title = this.modelService.getString('user_profile_recover_user_title');
		data.type = 'modal';
		this.alertWindow.show(data);

		const subWindow = this.modelService.alertResultSignal.subscribe((shouldRemove: boolean) => {
			subWindow.unsubscribe();
			this.alertWindow.close();
			console.log(shouldRemove);
			if (shouldRemove) {
				this.userProfileService.recoverUser(this.userData.userId).subscribe((res) => {
					if (res.result.ok === true) {
							this.router.navigate([this.path]);
							this.store.dispatch(pathActions.goBack());
							this.modelService.getUser().userChangeSignal.emit('');
						}
				});
			}
		});
	}

}
